var _excluded = ["className", "defaultValue", "disabled", "error", "height", "helperText", "helperTextState", "helperTextVisibility", "id", "label", "maxLength", "name", "onBlur", "onChange", "onFocus", "placeholder", "readOnly", "required", "resize", "separateLabel", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import Input from '../form_utils/input/input';
import { FormControl, FormHelperText, FormLabel } from '../form_utils';
import styles from '../form_utils/input/styles';
import propTypes from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TextArea = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      className,
      defaultValue,
      disabled = false,
      error = false,
      height = '120px',
      helperText,
      helperTextState = 'default',
      helperTextVisibility = 'auto',
      id,
      label,
      maxLength,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      readOnly = false,
      required = false,
      resize = false,
      separateLabel = false,
      value
    } = _ref,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  var labelId = label && id ? "".concat(id, "-label") : undefined;
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  return ___EmotionJSX(FormControl, {
    className: className,
    customStyle: styles,
    disabled: disabled,
    error: error,
    helperTextState: helperTextState,
    multiline: true,
    required: required,
    separateLabel: separateLabel
  }, label && ___EmotionJSX(FormLabel, {
    htmlFor: id,
    id: labelId
  }, label), ___EmotionJSX(Input, _extends({}, inputProps, {
    "aria-invalid": error,
    "aria-required": required,
    defaultValue: defaultValue,
    height: height,
    id: id,
    maxLength: maxLength,
    multiline: true,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    resize: resize,
    type: "text",
    value: value
  })), helperText && ___EmotionJSX(FormHelperText, {
    helperTextVisibility: helperTextVisibility,
    id: helperTextId
  }, helperText));
});
TextArea.propTypes = propTypes;
TextArea.displayName = 'TextArea';
export default TextArea;